<template>
  <div class="breadcrumb">
    <div class="contentarea bread_txt">
      <router-link to="/">Top</router-link>
      &gt;
      <router-link :to="{name:'KoukoDashi', params:{category:$route.params.category}}">{{info.categoryname}}</router-link>
      &gt;
      <span>{{point.title}}</span>
    </div>
  </div>
</template>

<style lang="less">
  .breadcrumb{
    padding: 25px 0;
    background: #D8D8D8;
    .bread_txt{
      font-size: 14px;
      text-align: left;
      a,
      span{
        color: #000;
      }
    }
  }

</style>

<script>
  export default {
    name: 'SubNavigation',
    props: {
      info: Object,
      point: Object
    }
  }
</script>